import app from 'flarum/forum/app';
import avatar from 'flarum/common/helpers/avatar';
import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import icon from 'flarum/common/helpers/icon';
import setting from '../helpers/setting';
import Link from 'flarum/common/components/Link';

const someUnique = (arr) => {
  const result = [];
  const map = new Map();
  const array = [...arr];
  for (const item of array) {
    if(!map.has(item.data.id)) {
      map.set(item.data.id, true);    // set any value to Map
      result.push(item);
    }
  }
  return result;
}

const sortedUsers = (users, curRoute) => {
  return someUnique(users.slice().sort(
    function (a, b) {
      if (curRoute === 'total_rankings.index') {
        return parseFloat(b.AdvPoints()) - parseFloat(a.AdvPoints());
      }
      return parseFloat(b.AdvPointsMonthly()) - parseFloat(a.AdvPointsMonthly());
    }));
}

/**
 * This page re-uses Flarum's IndexPage CSS classes
 */
export default class TotalRankingsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = true;
    this.users = [];
    this.curRoute = app.current.data.routeName;
    this.lastResultsCount = 1;
    this.refresh();
  }

  view() {
    let loading;

    if (this.loading) {
      loading = LoadingIndicator.component();
    } else if (this.lastResultsCount < 1) {
      loading = '';
    } else {
      loading = Button.component(
        {
          className: 'Button',
          onclick: this.loadMore.bind(this),
        },
        app.translator.trans('core.forum.discussion_list.load_more_button')
      );
    }
    const activeTotalClass = this.curRoute == 'total_rankings.index' ? "Button active" : "Button";
    const activeMonthlyClass = this.curRoute == 'monthly_rankings.index' ? "Button active" : "Button";
    const isTotalRoute = this.curRoute == 'total_rankings.index';
    const curUsers = sortedUsers(this.users, this.curRoute);
    // console.log(curUsers);

    return (
      <div className="IndexPage">
        {IndexPage.prototype.hero()}
        <div className="container">
          <div className="sideNavContainer">
            <nav className="IndexPage-nav sideNav">
              <ul>{listItems(IndexPage.prototype.sidebarItems().toArray())}</ul>
            </nav>
            <div className="IndexPage-results sideNavOffset">
              <div className='rankings-tab-links'>
                <Link
                    className={activeTotalClass}
                    href={app.route('total_rankings.index')} >{app.translator.trans('tolyod-advdiscus.forum.rankings.total_button')}</Link>
                  <Link
                    className={activeMonthlyClass}
                    href={app.route('monthly_rankings.index')}
                  >{app.translator.trans('tolyod-advdiscus.forum.rankings.monthly_button')}</Link>
              </div>
              <table class="rankings">
                <tr>
                  <th className="rankings-mobile">{app.translator.trans('fof-gamification.forum.ranking.rank')}</th>
                  <th>{app.translator.trans('fof-gamification.forum.ranking.name')}</th>
                  <th>{app.translator.trans('fof-gamification.forum.ranking.amount')}</th>
                </tr>
                {curUsers.map((user, i) => {
                  ++i;
                  const points = isTotalRoute ? user.AdvPoints() : user.AdvPointsMonthly();
                  // console.log(isTotalRoute, points);
                  return [
                    <tr className={'ranking-' + i}>
                      {i < 4 ? (
                        setting('customRankingImages', true) ? (
                          <img
                            className="rankings-mobile rankings-image"
                            src={app.forum.attribute('baseUrl') + app.forum.attribute(`fof-gamification.topimage${i}Url`)}
                          />
                        ) : (
                          <td className={'rankings-mobile rankings-' + i}>{icon('fas fa-trophy')}</td>
                        )
                      ) : (
                        <td className="rankings-4 rankings-mobile">{this.addOrdinalSuffix(i)}</td>
                      )}
                      <td>
                        <div className="PostUser">
                          <h3 className="rankings-info">
                            <Link href={app.route.user(user)} force={true}>
                              {i < 4 ? avatar(user, { className: 'info-avatar rankings-' + i + '-avatar' }) : ''} {username(user)}
                            </Link>
                          </h3>
                        </div>
                      </td>
                      {i < 4 ? <td className={'rankings-' + i}>{points}</td> : <td className="rankings-4">{points}</td>}
                    </tr>,
                  ];
                })}
              </table>
              <table className='rankings'>
                <tr>
                  <td className="rankings-4 rankings-mobile">&nbsp;</td>
                  <td style={{ width: '312px' }}>{loading}</td>
                  <td className="rankings-4">&nbsp;</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  refresh(clear = true) {
    if (clear) {
      this.loading = true;
      this.users = [];
    }

    return this.loadResults().then(
      (results) => {
        this.users = [];
        this.parseResults(results, this.curRoute);
      },
      () => {
        this.loading = false;
        m.redraw();
      }
    );
  }

  addOrdinalSuffix(i) {
    if (app.data.locale === 'en') {
      const j = i % 10;
      const k = i % 100;

      if (j === 1 && k !== 11) {
        return i + 'st';
      } else if (j === 2 && k !== 12) {
        return i + 'nd';
      } else if (j === 3 && k !== 13) {
        return i + 'rd';
      }
      return i + 'th';
    } else {
      return i;
    }
  }

  loadResults(offset) {
    const params = {};
    params.page = {
      offset: offset || 0,
      limit: 10,
    };

    const isTotalRoute = this.curRoute == 'total_rankings.index';
    if (isTotalRoute) {
      return app.store.find('total_rankings', params);
    }

    return app.store.find('monthly_rankings', params);
  }

  loadMore() {
    this.loading = true;

    this.loadResults(this.users.length).then(this.parseResults.bind(this));
  }



  parseResults(results, curRoute) {
    this.lastResultsCount = results.length;
    [].push.apply(this.users, results);

    this.loading = false;

    this.users.sort(function (a, b) {
      if (curRoute === 'total_rankings.index') {
        return parseFloat(b.AdvPoints()) - parseFloat(a.AdvPoints());
      }
      return parseFloat(b.AdvPointsMonthly()) - parseFloat(a.AdvPointsMonthly());
    });

    m.redraw();

    return results;
  }
}
